import { AsyncSubject, Observable } from "rxjs";

export class DependentChoice {
  idObservable: Observable<number>;
  label: string;
  detailsRoute: any;

  constructor(public topic: string) {}

  private subject: AsyncSubject<number>;

  setup(): Observable<number> {
    this.subject = new AsyncSubject();
    return this.subject;
  }

  choose(id: number, label: string): void {
    this.label = label;
    this.subject.next(id);
    this.subject.complete();
  }
  public static get EMPTY(): DependentChoice {
    return new DependentChoice("");
  }

  public get waiting(): Observable<number> {
    return this.subject;
  }
}
